import {
    select,
    selectAll,
} from "d3-selection"
import {transition} from "d3-transition"
import isEqual from "lodash.isequal"
import React from "react"
import {connect} from "react-redux"
import {withRouter} from "react-router-dom"
import {colors} from "../../../utils/colors"

let debounce

class Bar extends React.Component {
    constructor() {
        super()
        this.ref = React.createRef()
    }

    componentDidMount() {
        // add a tooltip div
        const elem = document.createElement("div")
        elem.id = "tooltip-dashboard-barchart"
        document.body.appendChild(elem)

        this.init()
    }

    componentDidUpdate(prevProps) {
        const {chartData, width} = prevProps

        // handle project distribution across wards dropdown.
        if (!isEqual(chartData, this.props.chartData)) {
            this.init()
        }
        // handle window resize
        if (width !== this.props.width) {
            this.barResponsive()
        }
    }

    barTransition() {

        const {yKey, y1Key, yScale, height, chartData} = this.props

        const t = transition().duration(800)

        selectAll(".layered-back-bar")
            .data(chartData)
            .transition(t)
            .attr("y", d => yScale(d[yKey]))
            .attr("height", d => height - yScale(d[yKey]))

        selectAll(".layered-front-bar")
            .data(chartData)
            .transition(t)
            .attr("y", d => yScale(d[y1Key]))
            .attr("height", d => height - yScale(d[y1Key]))

    }

    barResponsive() {
        const {chartData, height, xScale, yScale, xKey, yKey, y1Key} = this.props

        selectAll(".layered-back-bar")
            .data(chartData)
            .attr("x", d => xScale(d[xKey]))
            .attr("y", d => yScale(d[yKey]))
            .attr("width", xScale.bandwidth())
            .attr("height", d => height - yScale(d[yKey]))

        selectAll(".layered-front-bar")
            .data(chartData)
            .attr("x", d => xScale(d[xKey]))
            .attr("y", d => yScale(d[y1Key]))
            .attr("width", xScale.bandwidth())
            .attr("height", d => height - yScale(d[y1Key]))
    }

    init() {

        const {xKey, xScale, initialBarData, height} = this.props

        selectAll(".layered-back-bar")
            .data(initialBarData)
            .attr("x", d => xScale(d[xKey]))
            .attr("y", height)
            .attr("width", xScale.bandwidth())
            .attr("height", 0)

        selectAll(".layered-front-bar")
            .data(initialBarData)
            .attr("x", d => xScale(d[xKey]))
            .attr("y", height)
            .attr("width", xScale.bandwidth())
            .attr("height", 0)

        this.barTransition()
    }

    onMouseEnter = (e, datum) => {
        const {xKey, yKey, xScale, yScale, height} = this.props
        select(e.target)
            .style("opacity", "0.6")
            .style("cursor", "pointer")
        const tooltipData = {
            left: xScale(datum[xKey]),
            bottom: height - yScale(datum[yKey]),
            data: datum,
        }

        this.props.onMouseEnter(tooltipData)
    }
    onMouseLeave = e => {
        select(e.target).style("opacity", "1")
        const tooltipData = {
            left: 0,
            bottom: 0,
            data: "",
        }

        this.props.onMouseEnter(tooltipData)
    }
    onClick = (e, datum) => {
        clearTimeout(debounce)
        this.props.onClick(datum)
    }

    render() {
        const {xKey, xScale, chartData} = this.props

        const backgroundBar = chartData.map((datum, index) => (
            <rect
                key={`back_${datum[xKey]}` + index}
                className="layered-back-bar"
                x={xScale(datum[xKey])}
                y="0"
                width={xScale.bandwidth()}
                rx="2"
                ry="2"
                fill="#3b4555"
                opacity="0.8"
                onMouseEnter={e => {
                    this.onMouseEnter(e, datum)
                }}
                onMouseLeave={e => {
                    this.onMouseLeave(e)
                }}
                onClick={() => {
                    clearTimeout(debounce)
                    this.props.onClick(datum)
                }}
            />
        ))

        const frontBar = chartData.map((datum, index) => (
            <rect
                key={`front_${datum[xKey]}` + index}
                className="layered-front-bar"
                fill={colors.primary.pissYellow}
                x={xScale(datum[xKey])}
                y="0"
                width={xScale.bandwidth()}
                rx="2"
                ry="2"
                onMouseEnter={e => {
                    this.onMouseEnter(e, datum)
                }}
                onMouseLeave={e => {
                    this.onMouseLeave(e)
                }}
                onClick={() => {
                    clearTimeout(debounce)
                    this.props.onClick(datum)
                }}
            />
        ))

        return (
            <g className="bar-group">
                <g className="background-bar-group">
                    {backgroundBar}
                </g>
                <g ref={this.ref} className="layered-front-bar-group">
                    {frontBar}
                </g>
            </g>
        )
    }
}

const mapStateToProps = state => ({
    fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
})

export default withRouter(
    connect(
        mapStateToProps,
    )(Bar),
)



// WEBPACK FOOTER //
// ./src/components/charts/bar-chart/bar.js